import React, { useEffect, useRef } from 'react';

import { ArrowRight } from 'lucide-react';

import { IMcsaWildcard } from '../../../../types/mcsa.interface';
import { MCSA_JOURNEY_COPY } from '../../../../helpers/mcsa-journey.copy';

interface JourneyWildcardProps {
    wildcard: IMcsaWildcard;
    selected: number | null;
    revealed: boolean;
    onPick: (index: number) => void;
    onContinue: () => void;
}

export const JourneyWildcard = (props: JourneyWildcardProps) => {
    const { wildcard, selected, revealed, onPick, onContinue } = props;
    const messageRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!revealed) return;
        messageRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }, [revealed]);

    return (
        <div className='mcsa_journey_wildcard'>
            <div className='mcsa_journey_wildcard__card'>
                <div className='mcsa_journey_wildcard__star'>✦</div>
                <p className='mcsa_journey_wildcard__eyebrow'>{MCSA_JOURNEY_COPY.wildcard_eyebrow}</p>
                <h2>{wildcard.question}</h2>
                <div className='mcsa_journey_wildcard__opts'>
                    {wildcard.options.map((option, index) => {
                        const chosen = selected === index;
                        let state = '';
                        if (revealed) {
                            if (option.correct) state = ' mcsa_journey_wildcard__opt--correct';
                            else if (chosen) state = ' mcsa_journey_wildcard__opt--wrong';
                            else state = ' mcsa_journey_wildcard__opt--dim';
                        }
                        return (
                            <button
                                key={option.label}
                                type='button'
                                className={`mcsa_journey_wildcard__opt${state}`}
                                onClick={() => onPick(index)}
                            >
                                {option.label}
                            </button>
                        );
                    })}
                </div>
                {revealed && (
                    <div className='mcsa_journey_wildcard__msg' ref={messageRef}>
                        <p>{wildcard.message}</p>
                        <button type='button' className='btn btn--md btn--radius-full btn--primary' onClick={onContinue}>
                            <span>{MCSA_JOURNEY_COPY.wildcard_cta}</span>
                            <ArrowRight />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
